module.exports = [
  { path: '', code: 'en', ogLang: 'en_GB', name: 'English', title: 'English', label: 'En', isDefault: true },
  { path: 'de', code: 'de', ogLang: 'de', name: 'German', title: 'Deutsche', label: 'De' },
  { path: 'el', code: 'el', ogLang: 'gr', name: 'Greek', title: 'Ελληνικά', label: 'El' }
]